export const shipments = {
  title: '货运',
  resourceName: '货运',
  totalVolume: '总体积 (m³)',
  totalWeight: '总重量 (kg)',
  createBtn: '创建货运',
  editBtn: '编辑货运',
  updateBtn: '更新货运',
  deleteBtn: '删除货运',
  deleteConfirm: '您确定要删除此货运吗？',
  inWarehouse: '在仓库',
  split: {
    title: '拆分货运',
    description: '将货运拆分为更小的包裹。',
    successMessage: '拆分货运成功。',
  },
  add: {
    forOrder: '订单 {id}',
    viewOrder: '查看订单',
    placeholder: '添加货运表单正在开发中。您可以返回订单详情或货运列表。',
  },
  bulkCreate: {
    title: '批量创建货运',
    addRow: '添加行',
    duplicate: '复制行',
    view: '预览',
    preview: '预览货运',
    basicInfo: '基本信息',
    dimensions: '尺寸',
    warehouseInfo: '仓库信息',
    additionalInfo: '附加信息',
    totalRows: '总行数',
    summary: '总计',
    items: '货运',
    saving: '保存中...',
    createAll: '创建所有货运',
  },
  detail: {
    imagesTitle: '货运图片',
    imagesDescription: '即使货运已有图片，您仍然可以添加、删除或更新图片。',
    updateImagesSuccess: '货运图片更新成功',
    updateImagesError: '更新货运图片失败',
    saving: '保存中...',
    saveImages: '保存图片',
    savedSuccess: '保存成功',
    pickImage: '选择图片',
    captureImage: '拍照',
    uploading: '正在上传图片...',
    uploadSuccess: '已上传 {count} 张图片',
    uploadError: '上传图片失败',
    imageAlt: '图片 {index}',
  },
  statuses: {
    ALL: '全部',
    IN_FROM_WAREHOUSE: '在源仓库',
    TURN_AROUND: '回程',
    LOADING: '装载中',
    IN_CONT: '在集装箱',
    DEPARTED: '已出发',
    ARRIVED: '已到达',
    RETURNED: '已返回',
    IN_TO_WAREHOUSE: '在目标仓库',
    ON_DELIVERY: '正在交付',
    DELIVERED: '已交付',
    COMPLETED: '已完成',
    LOST: '遗失',
  },
  searchCode: {
    label: '按货运单号或提单号搜索',
    placeholder: '输入货运单号或提单号',
  },
  searchProduct: {
    label: '按产品搜索',
    placeholder: '输入产品名称',
  },
  searchCustomer: {
    label: '按客户搜索',
    placeholder: '输入客户代码',
  },
  filterWarehouse: {
    label: '按仓库过滤',
    placeholder: '选择仓库',
  },
  filterStartDate: {
    label: '货运返回日期',
    placeholder: '选择开始日期',
  },
  filterEndDate: {
    label: '货运返回日期',
    placeholder: '选择结束日期',
  },
  filterStatus: {
    label: '按状态过滤',
    placeholder: '选择状态',
  },
  filter: {
    placeholder: '按提单号、货运单号搜索...',
    advancedFilter: '高级筛选',
    clearFilter: '清除筛选',
    search: '搜索',
    ladingCodeOrder: '提单号 / 订单',
    ladingCode: '提单号',
    productNameLabel: '产品名称',
    productNamePlaceholder: '产品名称',
    customerCodeLabel: '客户代码',
    warehousePlaceholder: '仓库',
    statusLabel: '状态',
    fromDate: '从日期',
    toDate: '到日期',
    all: '全部',
  },
  list: {
    selectedCount: '已选 {count} 个货运',
    deleting: '删除中...',
    deleteSelected: '删除已选',
    deleteConfirmOne: '确定要删除此货运吗？',
    deleteSuccess: '已删除货运',
    bulkDeleteConfirm: '确定删除已选的 {count} 个货运？',
    bulkDeleteSuccess: '已删除 {count} 个货运',
    bulkDeleteError: '批量删除失败',
    viewMore: '查看更多',
    noImages: '暂无图片',
    ladingCode: '提单号',
    viewDetail: '查看详情',
    edit: '编辑',
    duplicate: '复制',
    split: '拆分',
    delete: '删除货运',
    duplicateConfirm: '确定要复制此货运吗？',
    duplicateSuccess: '复制成功',
    duplicateError: '复制失败',
    splitSuccess: '拆分成功',
    splitError: '拆分失败',
    splitDialogTitle: '拆分货运',
    splitDialogDescription: '当前货运有 {count} 件。输入新货运的件数（最多 {max} 件）。',
    splitNewPackLabel: '新件数',
    splitInvalidRange: '请输入 1 到 {max} 之间的数字',
    cancel: '取消',
    splitBtn: '拆分',
    processing: '处理中...',
    actions: '操作',
  },
  export: {
    button: '导出',
    loading: '正在导出...',
    success: 'Excel 文件导出成功',
    failed: '导出 Excel 文件失败',
    sheetName: '货运列表',
    fileName: '货运列表_{date}.xlsx',
    imageButton: '导出图片',
    columns: {
      orderCode: '订单号',
      ladingCode: '提单号',
      code: '货运单号',
      customerCode: '客户',
      subCustomerCode: '子客户代码',
      productName: '产品名称',
      numberOfPack: '件数',
      totalDimensionInM3: '体积 (m³)',
      totalWeight: '重量',
      fromWarehouseName: '发货仓库',
      toWarehouseName: '到货仓库',
      containerRefCode: '集装箱',
      statusLabel: '状态',
      orderCreatedAt: '订单创建日期',
      notes: '备注',
      createdAt: '创建日期',
      updatedAt: '更新日期',
    },
  },
  fields: {
    order: '订单',
    code: '货运单号',
    customer: '客户',
    customerCode: '客户代码',
    images: '图片',
    productName: '产品名称',
    productNameCn: '产品名称 (中文)',
    totalVolume: '总体积 (m³)',
    totalWeight: '总重量 (kg)',
    // Backward compatibility keys
    numberOfPack: '包裹数量',
    numberOfPackage: '包裹数量',
    warehouse: '仓库',
    fromWarehouse: '源仓库',
    toWarehouse: '目标仓库',
    container: '集装箱',
    status: '状态',
    pricePerKg: '每公斤价格',
    pricePerM3: '每立方米价格',
    createdAt: '创建日期',
    updatedAt: '更新日期',
    orderCreate: '订单创建日期',
    orderCreatedAt: '订单创建日期',
    notes: '备注',
    index: '序号',
    info: '信息',
    priceByWeight: '按重量计价',
    priceByVolume: '按体积计价',
    finalPrice: '最终价格',
    subCustomerCode: '客户代码 (子代码)',
    ladingCode: '提单号',
    dimensions: '尺寸',
    lengthOfPack: '包裹长度 (cm)',
    widthOfPack: '包裹宽度 (cm)',
    heightOfPack: '包裹高度 (cm)',
    weightOfPack: '包裹重量 (kg)',
    productDimensions: '产品尺寸',
    lengthOfProduct: '产品长度 (cm)',
    widthOfProduct: '产品宽度 (cm)',
    heightOfProduct: '产品高度 (cm)',
    weightOfProduct: '产品重量 (kg)',
    productMaterial: 'Chất liệu sản phẩm',
    information: 'Thông tin sản phẩm',
    createdBy: 'Người tạo',
    customerInfo: 'Thông tin khách hàng',
    packingInfo: 'Thông tin đóng kiện',
    productInfo: 'Thông tin sản phẩm',
    actions: 'Hành động',
    // Additional fields for ShipmentShow
    mainCode: 'Mã chính',
    subCode: 'Mã phụ',
    notAssignedCustomer: 'Chưa gắn khách',
    numberOfPackages: '包裹数量',
    packingDimensions: '包装尺寸',
    totalVolumeInM3: '总体积 (m³)',
    totalWeightInKg: '总重量 (kg)',
    totalDimension: '总尺寸 (m³)',
    totalDimensionInM3: '总体积 (m³)',
    productNameChinese: '产品名称 (中文)',
    additionalInfo: '附加信息',
    additionalInformation: '附加信息',
    warehouseInfo: '仓库信息',
    containerInfo: '集装箱信息',
    containerStatus: '集装箱状态',
    fromPort: '出发港口',
    toPort: '到达港口',
    agency: '代理',
    shippingLine: '船运公司',
    noContainerInfo: '没有集装箱信息',
    product: '产品',
    confirmationImage: '确认图片',
    // Timeline translations
    timeline: {
      title: '行程信息',
      steps: {
        inSourceWarehouse: '进入源仓库',
        inContainer: '进入集装箱',
        departed: '出发',
        arrived: '到达',
        inDestinationWarehouse: '进入目标仓库',
        delivered: '交付',
      },
      descriptions: {
        inSourceWarehouse: '货物进入源仓库',
        inContainer: '货物进入集装箱',
        departed: '集装箱从出发港口出发',
        arrived: '集装箱到达到达港口',
        inDestinationWarehouse: '货物进入目标仓库',
        delivered: '货物交付给客户',
      },
    },
    // Additional translations for other components
    warehouseSection: {
      goodsInWarehouse: '在仓库',
      goodsInWarehouseWithCount: '在仓库: {count} 货运',
      noShipmentsFound: '没有找到货运',
      customerCode: '客户代码',
      subCodeId: '子代码ID',
      deliveryNote: '交货单',
      deliveryNoteAdded: '已添加到交货单 {code}',
      notAdded: '未添加',
      total: '总计',
      selectedShipments: '{count} 货运已选择',
      weight: '重量',
      volume: '体积',
      price: '价格',
      weightPerPack: '重量/包裹',
      noName: '无名称',
      numberOfPacks: '包裹数量',
      containerId: '集装箱 ID',
      containerCode: '集装箱编号',
      shipmentPrice: '批次价格',
    },
    actionsSection: {
      toWarehouse: '进入仓库',
      missingPackages: '缺失包裹',
      missingPackagesTitle: '缺失包裹',
      enterActualPackages: '输入实际包裹数量',
      valueMustBeBetween: '值必须在0到{max}之间',
      missingPackagesDueTo: '缺失包裹的原因:',
      lostPackages: '丢失包裹',
      missingFromSourceWarehouse: '缺失源仓库',
      packagesInSystem: '系统包裹数量',
      actualPackages: '实际包裹数量',
      willGoToDestination: '(将进入目标仓库)',
      missing: '缺失',
      packages: '包裹',
      missingFromSource: '缺失源仓库',
      cancel: '取消',
      processing: '处理中...',
      save: '保存',
    },
    MVD: '提单号',
    actual: '实际',
  },
  tabs: {
    general: '通用信息',
    shipments: '货运',
    price: '价格信息',
    customsDeclaration: '海关申报',
  },
  totalPriceShipments: '总价格',
  totalPrice: '总价格',
  titles: {
    view: '货运详情',
    show: '货运详情',
    edit: '编辑货运',
    create: '创建货运',
    list: '货运列表',
  },
  buttons: {
    removeFromContainer: '从集装箱中移除',
    saveOrder: '保存货运顺序',
    confirmation: '确认',
    shareShipment: '分享货运',
  },
  messages: {
    noData: '暂无数据',
    totalShipments: '共 {total} 个货运',
    customerSelected: '客户已选择',
    haveSubCodeButNoCustomer: '找到子代码但未找到对应客户',
    notFoundCustomerWithCode: '未找到对应客户代码',
    errorFetchingCustomer: '查找客户时出错',
    required: {
      numberOfPack: '请输入包裹数量',
      subCustomerCode: '请输入客户代码',
      lengthOfPack: '请输入长度',
      widthOfPack: '请输入宽度',
      heightOfPack: '请输入高度',
      weightOfPack: '请输入重量',
      pricePerKg: '请输入每公斤价格',
      pricePerM3: '请输入每立方米价格',
      fromWarehouseId: '请选择源仓库',
      toWarehouseId: '请选择目标仓库',
      containerId: '请选择集装箱',
      productName: '请输入产品名称',
      images: '请上传图片',
    },
    positive: {
      numberOfPack: '包裹数量必须大于或等于0',
      lengthOfPack: '长度必须大于或等于0',
      widthOfPack: '宽度必须大于或等于0',
      heightOfPack: '高度必须大于或等于0',
      weightOfPack: '重量必须大于或等于0',
    },
    warehouse: {
      toWarehouseId: '"目标仓库"必须不同于"源仓库"',
    },
  },
  form: {
    createTitle: '创建货运',
    editTitle: '编辑货运',
    help: {
      numberOfPack: '货运中的包裹数量',
      subCustomerCode: '客户代码 (子代码) 用于货运',
      customer: '客户将根据子代码自动选择',
      ladingCode: '提单号用于货运',
      productName: '货运中的产品名称',
      productNameCn: '产品名称 (中文) (如果存在)',
      selectFromWarehouse: '选择源仓库',
      selectToWarehouse: '选择目标仓库',
    },
  },
  customsDeclaration: {
    title: '海关申报信息',
    description: '这部分包含货运的海关申报信息。',
    fields: {
      customsDeclarationNumber: '海关申报号',
      customsDeclarationDate: '申报日期',
      customsOffice: '海关办公室',
      customsAgent: '海关代理',
      importExportType: '进口/出口类型',
      goodsDescription: '货物描述',
      hsCode: 'HS Code (海关编码)',
      quantity: '数量',
      unitValue: '单位价值',
      totalValue: '总价值',
      currency: '货币',
      shipments: '货运',
    },
  },
}
